import {MenuItemConfigurationModel} from './menu-item-configuration.model';

export class MenuConfigurationModel {
  MenuID: string;
  MenuName: string = '';

  cfgMenuItems: MenuItemConfigurationModel[] = [];
}
